/**
 * Default investor onboarding flow — settings-shaped for future API replacement.
 * TODO(Phase 2): Load from GET /onboard/investor-onboarding?domain_url=
 * TODO(Admin config): UniqueCoop manager portal should expose a stepper builder
 *   (add/remove/reorder steps per org) — investor signup reads the same config shape.
 */
export const DEFAULT_INVESTOR_ONBOARDING_FLOW = {
  flow_key: "default_investor",
  steps: [
    {
      id: "account",
      label: "Account created",
      required: true,
      route: "/invest/signup",
    },
    {
      id: "profile",
      label: "Profile details",
      required: true,
      route: "/invest/onboarding",
    },
    {
      id: "kyc",
      label: "Identity verification",
      required: false,
      skippable: true,
      route: "/invest/onboarding/verification",
    },
    {
      id: "welcome",
      label: "Welcome",
      required: true,
      route: "/invest/dashboard",
    },
  ],
};

export function resolveInvestorOnboardingFlow(companySettings) {
  const fromApi = companySettings?.investor_onboarding_config;
  if (fromApi?.steps?.length) {
    return fromApi;
  }
  return DEFAULT_INVESTOR_ONBOARDING_FLOW;
}

export function getNextOnboardingStep(flow, progress = {}) {
  for (const step of flow.steps) {
    if (!step.required) continue;
    if (!progress[step.id]) return step;
  }
  return null;
}

export function isOnboardingComplete(flow, progress = {}) {
  return !getNextOnboardingStep(flow, progress);
}
